module.exports = __webpack_public_path__ + "img/ios7.3ac43a18.png";